import Inquiry from './Inquiry.js';
import withAllowedRoles from 'hoc/withAllowedRoles';
import { ROLES } from '../../constants';

export default withAllowedRoles(
  [
    ROLES.CLIENT,
    ROLES.MENTOR,
    ROLES.MASTER,
    ROLES.EXPERT,
    ROLES.SPECIALIST,
    ROLES.FOUNDER,
    ROLES.HELPER,
  ],
  Inquiry,
);
